import React, { useEffect } from "react";
import { Table } from "antd";
import { useCustomerModel } from "../customerModel";
import { IMdCustomerDetail } from "../customerService";
import { ColumnsType } from "antd/es/table";

const columns: ColumnsType<IMdCustomerDetail> = [
    {
        align: "center",
        title: '版本',
        width: 120,
        dataIndex: 'branch',
    }, {
        align: "center",
        title: '禁用',
        width: 120,
        dataIndex: 'enable',
        render: v => v === 1 ? "否" : "是"
    }, {
        align: "center",
        title: '编码',
        width: 160,
        dataIndex: 'code',
    }, {
        align: "center",
        title: '名称',
        width: 160,
        dataIndex: 'name',
    }, {
        align: "center",
        title: '类型编码',
        width: 160,
        dataIndex: 'categoryCode',
    }, {
        align: "center",
        title: '类型名称',
        width: 160,
        dataIndex: 'categoryName',
    }, {
        align: "center",
        title: '级别',
        width: 120,
        dataIndex: 'level',
    }, {
        align: "center",
        title: '联系人',
        width: 160,
        dataIndex: 'contact',
    }, {
        align: "center",
        title: '联系电话',
        width: 160,
        dataIndex: 'phone',
    }, {
        align: "center",
        title: '办公电话',
        width: 160,
        dataIndex: 'tel',
    }, {
        align: "center",
        title: '传真',
        width: 160,
        dataIndex: 'fax',
    }, {
        align: "center",
        title: '邮箱',
        width: 300,
        dataIndex: 'email',
    }, {
        align: "center",
        title: '网站',
        width: 300,
        dataIndex: 'website',
    }, {
        align: "center",
        title: '地址',
        width: 300,
        dataIndex: 'address',
    }, {
        align: "center",
        title: '发票抬头',
        width: 300,
        dataIndex: 'invoiceHeader',
    }, {
        align: "center",
        title: '营业执照号',
        width: 160,
        dataIndex: 'businessLicenseNo',
    }, {
        align: "center",
        title: '开户行',
        width: 300,
        dataIndex: 'bank',
    }, {
        align: "center",
        title: '账号',
        width: 160,
        dataIndex: 'bankAccount',
    }, {
        align: "center",
        title: '邮寄地址',
        width: 300,
        dataIndex: 'postAddress',
    }, {
        align: "center",
        title: '法人',
        width: 160,
        dataIndex: 'corporation',
    }, {
        align: "center",
        title: '经营范围',
        width: 300,
        dataIndex: 'businessScope',
    }, {
        align: "center",
        title: '状态',
        dataIndex: 'status',
        width: 120,
        render: (v) => v === 0 ? "正常" : "异常"
    },
    {
        align: "center",
        title: '备注',
        dataIndex: 'note',
    },

];

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useCustomerModel();


    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IMdCustomerDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
